'use strict'

domConfig = require './dom_config'

module.exports =
  adjustOrphanDeal: ->
    return unless domConfig.get()?.enabledFeatures?.showThreeUpBrowsePage
    cardsSelector = $('.card-ui.cui-c-udc')
    return if cardsSelector.length < 15
    lastDealLeftOffset = $(cardsSelector[cardsSelector.length - 3]).offset().left
    titleLeftOffset = $('#pull-page-header-title').offset().left
    offsetDiff = lastDealLeftOffset - titleLeftOffset
    ratioToTheLeft = offsetDiff * 3 / $('#pull-results').width()

    if ratioToTheLeft < 0.5
      # One Orphan Deal, show two hidden deals
      $('.cui-c-udc.cui-udc-hidden').show()
    else if ratioToTheLeft < 1
      # Two Orphan Deal, show one hidden deals
      $($('.cui-c-udc.cui-udc-hidden')[0]).show()
